<template>
    <div class="SatisfactionSurveySet" v-loading.fullscreen.lock="fullscreenLoading" :style="{ height: Height - 105 + 'px'}">
        <el-container :style="{ height: Height - 105 + 'px'}">
            <el-header height="80px">
                <el-row>
                    <el-col>
                        <h2>满意度调研设置</h2>
                    </el-col>
                    <el-col :span="12" style="text-align: left; padding-left: 10px;">
                        <el-popover
                            placement="bottom-start"
                            width="400"
                            trigger="manual"
                            v-model="visible">
                            <el-form ref="ruleForms" :model="queryform" label-width="120px">
                                <el-form-item label="满意度调研状态">
                                    <!-- <el-input v-model="queryform.type"></el-input> -->
                                    <el-select style="width: 100%;" v-model="queryform.status" placeholder="请选择满意度调研状态" clearable>
                                        <el-option label="未发布" :value="0">
                                        </el-option>
                                        <el-option label="已发布" :value="1">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="调研名称">
                                    <el-input v-model="queryform.keyword"></el-input>
                                </el-form-item>
                            </el-form>
                            <el-row>
                                <el-col style="text-align: right;">
                                    <el-button type="primary" @click="Reset">重置</el-button>
                                    <el-button type="primary" @click="ConfirmQuery">确认</el-button>
                                </el-col>
                            </el-row>
                            <el-button type="primary" slot="reference" @click="visible = !visible">查询</el-button>
                        </el-popover>
                    </el-col>
                    <el-col :span="12">
                        <el-button type="primary" @click="AddSatisfactionSurveySet">新增</el-button>
                    </el-col>
                </el-row>
            </el-header>
            <el-main>
                <el-table :height="Height - 265" :data="tableData" border style="width: 100%">
                    <el-table-column prop="title" label="调研名称" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="status" label="满意度调研状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status === 0">未发布</span>
                            <span v-if="scope.row.status === 1">已发布</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="dateS" label="开始调研时间" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="dateE" label="结束调研时间" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="address" label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="EditSatisfactionSurveySet(scope.row)">编辑</el-button>
                            <el-button type="text" @click="DelSatisfactionSurveySet(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-dialog :title="title" :visible.sync="SatisfactionSurveySet" top="7vh" width="700px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" custom-class="SatisfactionSurveySet">
                    <el-form :model="form" :rules="rules" ref="ruleForm" label-width="120px">
                        <el-form-item label="调研名称" prop="title">
                            <el-input v-model="form.title"></el-input>
                        </el-form-item>
                        <el-form-item label="满意度调研状态">
                            <el-select v-model="form.status" placeholder="请选择">
                                <el-option label="未发布" :value="0">
                                </el-option>
                                <el-option label="已发布" :value="1">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="调研发布时间" v-if="form.status === 1">
                            <el-date-picker
                                v-model="form.timeSlot"
                                type="datetimerange"
                                :picker-options="pickerOptions"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期" align="right">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="调研模板">
                            <el-select v-model="form.muban_id" placeholder="请选择">
                                <el-option v-for="item in SurveyTemplateData" :key="item.id" :label="item.title" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="SatisfactionSurveySet = false">取 消</el-button>
                        <el-button type="primary" @click="SaveSatisfactionSurveySet" :loading="confirmloding">确 定</el-button>
                    </div>
                </el-dialog>
            </el-main>
            <el-footer>
                <el-row>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="total"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="12" style="text-align: center;">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="->, sizes"
                            :total="total">
                        </el-pagination>
                    </el-col>
                </el-row>
            </el-footer>
        </el-container>
  </div>
</template>

<script>
/*eslint-disable */
import { getToken, getAdminId } from "../../../utils/auth";
import https from "../../../utils/http";
export default {
    name: "SatisfactionSurveySet",
    data () {
        return {
            url: https.http,
            visible: false,
            fullscreenLoading: false,
            tableData: [],
            SatisfactionSurveySet: false,
            form: {
                title: '',
                status: 1,
                timeSlot: [],
                muban_id: ''
            },
            title: '',
            currentPage: 1,
            Size: 20,
            total: 1,
            visible: false,
            queryform: {
                status: '',
                keyword: ''
            },
            Uploaddata: {
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            },
            http: https.https,
            preview: false,
            fileList: [],
            rules: {
                title: [
                    { required: true, message: '请输入满意度调研设置名称', trigger: 'blur' }
                ]
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 7
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 30
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近三个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 90
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    }
                ]
            },
            confirmloding: false,
            SurveyTemplateData: []
        }
    },
    mounted() {

    },
    watch: {

    },
    methods: {
        AddSatisfactionSurveySet () {
            this.SatisfactionSurveySet = true
            this.title = '新增满意度调研设置'
            this.form = {
                title: '',
                status: 1,
                timeSlot: [],
                muban_id: ''
            }
            this.fileList = []
        },
        handleSizeChange(size) {
            this.Size = size
            this.fullscreenLoading = true
            this.GetSatisfactionSurveySetList(this.queryform.keyword, this.queryform.room)
        },
        handleCurrentChange(page) {
            this.currentPage = page
            this.fullscreenLoading = true
            this.GetSatisfactionSurveySetList(this.queryform.keyword, this.queryform.room)
        },
        GetSatisfactionSurveySetList (keyword, room) {
            let data = {
                limit: this.Size,
                page: this.currentPage,
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken(),
            }
            data.status = this.queryform.status
            data.keyword = this.queryform.keyword
            this.$store.dispatch('SatisfactionSurveySetListShow', data).then(res => {
                this.fullscreenLoading = false
                this.total = res.something
                for (let item in res.data) {
                    res.data[item].status = Number(res.data[item].status)
                }
                this.tableData = res.data
                this.form = {
                    title: '',
                    status: 1,
                    timeSlot: [],
                    muban_id: ''
                }
                this.visible = false
            })
        },
        Reset () {
           this.$refs['ruleForms'].resetFields();
           this.queryform = {
                status: '',
                keyword: ''
            }
        },
        ConfirmQuery() {
            this.currentPage = 1
            this.GetSatisfactionSurveySetList(this.queryform.keyword, this.queryform.room)
        },
        SaveSatisfactionSurveySet() {
            let that = this;
            let data = JSON.parse(JSON.stringify(this.form));
            data.ADMIN_ID = getAdminId();
            data.ADMIN_TOKEN = getToken();
            data.admin_id = getAdminId();
            data.dateS = data.timeSlot[0]
            data.dateE = data.timeSlot[1]
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.confirmloding = true;
                    that.$store.dispatch('SaveSatisfactionSurveySet', data).then(res => {
                        if (res.flag) {
                            that.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                            that.confirmloding = false;
                            that.SatisfactionSurveySet = false;
                            that.fullscreenLoading = true;
                            that.GetSatisfactionSurveySetList(that.queryform.keyword, that.queryform.room);
                        } else {
                            that.$message({
                                message: res.message,
                                type: 'warning'
                            });
                        };
                    });
                } else {
                    return false;
                };
            });
            
        },
        EditSatisfactionSurveySet(row) {
            this.SatisfactionSurveySet = true
            this.title = '编辑满意度调研设置'
            row.timeSlot = []
            row.timeSlot.push(row.dateS)
            row.timeSlot.push(row.dateE)
            this.form = JSON.parse(JSON.stringify(row))
        },
        DelSatisfactionSurveySet(row) {
            this.$confirm('是否删除该满意度调研设置？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                row.ADMIN_ID = getAdminId();
                row.ADMIN_TOKEN = getToken();
                this.$store.dispatch('DelSatisfactionSurveySet', row).then(res => {
                     if (res.flag) {
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        })
                        this.fullscreenLoading = true
                        this.GetSatisfactionSurveySetList(this.queryform.keyword, this.queryform.room)
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'warning'
                        })
                    }
                })
            }).catch(() => {
            })
        },
        GetSurveyTemplate () {
            let data = {
                limit: 10000,
                page: 1,
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken(),
            }
            this.$store.dispatch('SatisfactionSurveyTemplateListShow', data).then(res => {
                this.SurveyTemplateData = res.data
            })
        }
    },
    created() {
        this.fullscreenLoading = true
        this.GetSurveyTemplate()
        this.GetSatisfactionSurveySetList(this.queryform.keyword, this.queryform.room)
    },
    computed: {
        Height() {
            return this.$store.state.loginModule.Height;
        }
    }
}
</script>

<style>
.SatisfactionSurveySet {
    width: 100%;
}
.SatisfactionSurveySet .el-header .el-row .el-col {
    height: 40px;
    line-height: 40px;
}
.SatisfactionSurveySet .el-header .el-row .el-col h2 {
    text-align: center;
}
.SatisfactionSurveySet .el-header .el-row .el-col {
    text-align: center;
}
.SatisfactionSurveySet .el-header .el-row .el-col:last-child {
    text-align: right;
}
.SatisfactionSurveySet .el-main {
    padding-top: 0px;
    padding-bottom: 0px;
}
.SatisfactionSurveySet .el-main .SatisfactionSurveySet .el-dialog__body {
    padding-top: 0px;
    padding-bottom: 0px;
}
.SatisfactionSurveySet .el-main .SatisfactionSurveySet .el-dialog__body .el-form-item .el-select, .SatisfactionSurveySet .el-main .SatisfactionSurveySet .el-dialog__body .el-form-item .el-date-editor {
    width: 100%;
}
</style>
